import { ACTIONS } from "../../common/constants";

const activeInactiveDataReducer = function (state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_ACTIVE_INACTIVE_DATA:
      return action.data;
    default:
      return state;
  }
};

export default activeInactiveDataReducer;
